import parser from "refractor/parser";
export default parser;